if (typeof Plugin_Pdf == 'undefined') {

    var Plugin_Pdf = {
        init: function () {

            var buttonPdf = $('#button-generate-pdf-request');
            if (!buttonPdf.length) {
                return;
            }

            buttonPdf
                .off('click')
                .on('click', function (e) {
                e.preventDefault();
                Plugin_Pdf.generatePdfRequest();
            });
        },

        generatePdfRequest: function () {

            var url = window.location.protocol + '//' + window.location.host;
            var idItem = $('#idItem').val();

            if (idItem.length) {

                url += '/plugin/PluginPdf/ajaxGeneratePdfRequest';
                url += '?requestId=' + idItem;

                $.ajax({
                    type: 'get',
                    url: url,
                    dataType: "json",
                    global: false,
                    beforeSend: function() {
                        Lemo_Alert.addInfo('Generuji dokument pdf žádosti', 'generatePdfRequestBeforeSend');
                    },
                    complete: function() {
                        Lemo_Alert.closeById('generatePdfRequestBeforeSend');
                    },
                    success: function(r) {

                        if(r.hasOwnProperty('messages')) {
                            Lemo_Alert.addMany(r.messages);
                        }

                        if(r.hasOwnProperty('status') && true == r['status'] && r.hasOwnProperty('data')) {
                            var data = r['data'];
                            if(data.hasOwnProperty('fileId') && data['fileId']) {
                                window.location = '/plugin/PluginPdf/ajaxDownloadPdfRequest?fileId=' + data['fileId'];
                            }
                        }
                    },
                    error: function(xhr) {
                        Lemo_Alert.addDanger('Generování dokumentu žádosti selhalo ...', 'generatePdfRequestError');
                    }
                });
            }

        }
    };
}

$(document)
    .ready(function () {
        Plugin_Pdf.init();
    });

